module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/zen-observable/index.js
// module id = 1146
// module chunks = 0